// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knowledgeBase_wrapper__RnvAD {
  width: 100%;
  display: flex;
  align-items: center;
  row-gap: 30px;
  flex-direction: column; }

.knowledgeBase_infoContainer__i1FvS {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  flex-direction: row;
  column-gap: 10px;
  padding: 18px 10px;
  box-shadow: 0px 0px 8px 0px rgba(42, 98, 149, 0.25);
  border-radius: var(--Corner-radius, 4px);
  background: var(--website-white, #FFF); }
  .knowledgeBase_infoContainerspan__Y8\\+kW {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }

.knowledgeBase_titleContainer__snqEb {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  justify-content: space-between; }

.knowledgeBase_categoryTitle__20Gxs {
  font-weight: 600;
  font-size: 24px;
  line-height: 150%; }

.knowledgeBase_categoriesListContainer__2OK94 {
  width: 100%;
  display: flex;
  row-gap: 10px;
  column-gap: 10px;
  flex-wrap: wrap; }

.knowledgeBase_promptsListContainer__1wecb {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; }

.knowledgeBase_modal__Smrf1 {
  max-width: 560px;
  max-height: 850px;
  height: max-content;
  overflow: hidden;
  position: relative;
  background-color: #ffffff;
  z-index: 2; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/knowledgeBase/knowledgeBase.module.scss","webpack://./src/styles/common.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,WAAW;ECVX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;ECiCvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EFxBjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,wCAAwC;EACxC,sCAAsC,EAAA;EACtC;IEgBA,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;AFbnB;EACE,WAAW;ECzBX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EDyBvB,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EE1BE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AF4BnB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,WAAW;EC5CX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;ED4CvB,sBAAsB,EAAA;;AAGxB;EACI,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  row-gap: 30px;\n  flex-direction: column;\n}\n\n.infoContainer {\n  width: 100%;\n  @include flexCenter;\n  @include body1;\n  flex-direction: row;\n  column-gap: 10px;\n  padding: 18px 10px;\n  box-shadow: 0px 0px 8px 0px rgba(42, 98, 149, 0.25);\n  border-radius: var(--Corner-radius, 4px);\n  background: var(--website-white, #FFF);\n  &span {\n    @include body1;\n  }\n}\n\n.titleContainer {\n  width: 100%;\n  @include flexCenter;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.categoryTitle {\n  @include h2;\n}\n\n.categoriesListContainer {\n  width: 100%;\n  display: flex;\n  row-gap: 10px;\n  column-gap: 10px;\n  flex-wrap: wrap;\n}\n\n.promptsListContainer {\n  width: 100%;\n  @include flexCenter;\n  flex-direction: column;\n}\n\n.modal {\n    max-width: 560px;\n    max-height: 850px;\n    height: max-content;\n    overflow: hidden;\n    position: relative;\n    background-color: #ffffff;\n    z-index: 2;\n}","\n@mixin flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `knowledgeBase_wrapper__RnvAD`,
	"infoContainer": `knowledgeBase_infoContainer__i1FvS`,
	"infoContainerspan": `knowledgeBase_infoContainerspan__Y8+kW`,
	"titleContainer": `knowledgeBase_titleContainer__snqEb`,
	"categoryTitle": `knowledgeBase_categoryTitle__20Gxs`,
	"categoriesListContainer": `knowledgeBase_categoriesListContainer__2OK94`,
	"promptsListContainer": `knowledgeBase_promptsListContainer__1wecb`,
	"modal": `knowledgeBase_modal__Smrf1`
};
export default ___CSS_LOADER_EXPORT___;
